import BaseComponent from 'source/lib/base_component';

import template from './template.html';

const RealmSelect = BaseComponent.extend({
    name: 'dropdown',
    template,
    initialize(...args) {
        BaseComponent.prototype.initialize.apply(this, args);
        this.bindInput();
    },
    bindInput() {
        this.$input = this.$('.js-select');
    },
});

export default RealmSelect;
